import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import injectCSSVariables from './../injectStyle';

const FONT_OPTIONS = [
  {
    label: 'Roboto',
    value: 'Roboto',
    url: 'https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap'
  },
  {
    label: 'Open Sans',
    value: 'Open Sans',
    url: 'https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap'
  },
  {
    label: 'Lato',
    value: 'Lato',
    url: 'https://fonts.googleapis.com/css?family=Lato:400,700&display=swap'
  },
  {
    label: 'Montserrat',
    value: 'Montserrat',
    url: 'https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap'
  }
  // Add more fonts as needed
];

function FontDropdown({ onAutoTabSwitch }) {
  const [selectedFont, setSelectedFont] = useState(FONT_OPTIONS[0]);

  useEffect(() => {
    const font = FONT_OPTIONS.find(f => f.value === selectedFont);
    if (!font) return;

    // Remove any previous font link
    let link = document.getElementById('dynamic-font-link');
    if (link) link.remove();

    // Add new font link
    link = document.createElement('link');
    link.id = 'dynamic-font-link';
    link.rel = 'stylesheet';
    link.href = font.url;
    document.head.appendChild(link);

    // Set CSS variable on body
    // document.body.style.setProperty('--slds-g-font-family-base', `'${font.value}', sans-serif`);
    injectCSSVariables([{
      name: "--slds-g-font-family-base",
      value: `'${font.value}', sans-serif`
    }])

    onAutoTabSwitch('pages');

    // Cleanup on unmount
    return () => {
      if (link) link.remove();
    };
  }, [selectedFont]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      {/* <label htmlFor="font-dropdown" style={{ fontWeight: 500 }}>Font:</label> */}
      <Dropdown
        id="font-dropdown"
        value={selectedFont}
        options={FONT_OPTIONS}
        onChange={e => setSelectedFont(e.value)}
        optionLabel="label"
        optionValue="value"
        className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm"
        style={{ minWidth: 180, height: '38px' }}
        placeholder="Select a font"
      />
    </div>
  );
}

export default FontDropdown; 